export {};

window.API_URL = "http://localhost:7108";
window.API_URL = "https://api.kana.earth";
